import './setup';

import { Telemetry } from '@affine/core/components/telemetry';
// import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';

import { App } from './app';

function mountApp() {
  // oxlint-disable-next-line @typescript-eslint/no-non-null-assertion
  const root = document.getElementById('app')!;
  createRoot(root).render(
    <>
      <Telemetry />
      <App />
    </>
  );
}

try {
  mountApp();
} catch (err) {
  console.error('Failed to bootstrap app', err);
}
// Hash update trigger: 2025年 9月16日 星期二 10时33分56秒 CST
